import React from 'react';

import CustomMap from '../components/CustomMap';

export default () => (
		<CustomMap/>
);
